import React from 'react';
import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Input, Button } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import AuthService from '../../Services/AuthService';
import { Auth } from 'aws-amplify';

interface Props {
  changeState: (newState: string) => void;
  setError: (error: string) => void;
  form: any;
  email: string | null;
  password: string | null;
}

interface State {
  submitting: boolean;
}

class VerificationForm extends React.Component<Props, State> {
  state = {
    submitting: false,
  };
  submitCode = (): void => {
    const { form } = this.props;
    this.setState({
      submitting: true,
    });
    form.validateFields(async (err: boolean, values: any) => {
      if (err) {
        this.setState({
          submitting: false,
        });
        return;
      }
      // Initiate Auth, and once we receive the challenge back, we can redirect the user
      const authService = new AuthService();
      if (!this.props.email) {
        this.props.changeState('passwordLogin');
        this.props.setError('An error occurred');
        return;
      }
      try {
        await authService.submitCode(this.props.email, values.code);
        if (this.props.password) {
          await authService.loginWithPassword(this.props.email, this.props.password);
        } else {
          this.props.changeState('passwordLogin');
        }
      } catch (e) {
        this.setState({
          submitting: false,
        });
        this.props.setError('An error occurred');
        this.props.changeState('passwordLogin');
      }
    });
  };
  resendCode = async (): Promise<void> => {
    if (!this.props.email) {
      this.props.changeState('passwordLogin');
      this.props.setError('An error occurred');
      return;
    }
    this.setState({
      submitting: true,
    });
    await Auth.resendSignUp(this.props.email);
    this.setState({
      submitting: false,
    });
  };
  render(): React.ReactElement {
    const { getFieldDecorator } = this.props.form;
    const { submitting } = this.state;
    return (
      <Form>
        <h2>Verify Your Account</h2>
        <p>You should have received a verification code in your inbox. Please enter the code below.</p>
        <FormItem>
          {getFieldDecorator('code', {
            rules: [{ required: true, message: 'Please input your verification code!' }],
          })(<Input placeholder="Verification Code" />)}
        </FormItem>

        <FormItem>
          <Button
            disabled={submitting}
            type="primary"
            onClick={(): void => this.submitCode()}
            style={{ width: '100%' }}
            loading={this.state.submitting}
          >
            Submit Code
          </Button>
          Or{' '}
          <Button disabled={submitting} type="link" onClick={this.resendCode}>
            click to resend code.
          </Button>
        </FormItem>
      </Form>
    );
  }
}

const Verification = Form.create<Props>()(VerificationForm);

export default Verification;
